import CompanySettingsPage from "./CompanySettingsPage";

export default function TripRange() {
  return (
    <CompanySettingsPage
      title="Trip Range"
      fields={[
        { name: "minTripMiles", label: "Minimum trip (miles)", type: "number" },
        { name: "maxTripMiles", label: "Maximum trip (miles)", type: "number" },
      ]}
    />
  );
}
